// extracted by mini-css-extract-plugin
export default {"radio":"QuestionAnswer_radio__nFlc+","textField":"QuestionAnswer_textField__xSUcW","checkbox":"QuestionAnswer_checkbox__tnVbk"};